import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.sass']
})
export class ConfirmComponent implements OnInit {

  constructor() { }

  @Output() public accept = new EventEmitter<string>();
  @Output() public dismiss = new EventEmitter<string>();
  @Output() public reject = new EventEmitter<string>();
  @Input() public text: string
  @Input() public acceptBtnText: string = null;
  @Input() public acceptBtnText2: string = null;
  @Input() public rejectBtnText: string = null;
  @Input() public rejectBtnText2: string = null;
  @Input() public block: boolean = false;

  public onDismiss(text: string){
    this.dismiss.emit(text)
  }

  public onAccept(text: string){
    this.accept.emit(text)
  }

  public onReject(text: string){
    this.reject.emit(text)
  }

  ngOnInit() {
    console.log(this.text);
    
  }

}
